import script from "./ai-box.vue?vue&type=script&setup=true&lang=js"
export * from "./ai-box.vue?vue&type=script&setup=true&lang=js"

import "./ai-box.vue?vue&type=style&index=0&id=7c11e57a&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c11e57a"]])

export default __exports__